import { distanceUtil } from '../../lib/distanceUtil-sidecar'
import { l } from '../../lib/imports'
import { voyageCamera } from './voyageCamera-sidecar'
import { EVoyageCrewType, IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageGameStatus_enemyShips } from './voyageGameStatus_enemyShips-sidecar'
import type { IVoyageIndicator } from './voyageIndicators'
import { voyageIndicators } from './voyageIndicators-sidecar'
import { voyagePicker } from './voyagePicker-sidecar'
import { voyageSaver } from './voyageSaver-sidecar'
import { voyageSystems } from './voyageSystems-sidecar'
import { voyageTestParams } from './voyageTestParams-sidecar'
import { voyageUiTutorial } from './voyageUiTutorial-sidecar'

const namespace = 'voyage-game-tutorial'

let _skipTutorial = true && voyageTestParams.isDevMode
export function signalSkip() {
  _skipTutorial = true
  // voyageUiTutorial.setOpen(false)
}
export function getIsSkipped() {
  return _skipTutorial
}

function* gen_selectCrew(
  ind: IVoyageIndicator,
  cr: IVoyageCrew,
  title: string,
) {
  let text =
    'Select crewmember ' + cr.name + '\n\n(Click highlighted circle to select)'
  voyageUiTutorial.setText(title, text)

  while (voyagePicker.get().selectedCrew !== cr) {
    voyageIndicators.moveToIJ(ind, cr)
    if (_skipTutorial) {
      return 0
    }
    yield 0
  }
  yield voyageUiTutorial.completeStep()
}

function* gen_moveToSystem(
  ind: IVoyageIndicator,
  cr: IVoyageCrew,
  sysTag: string,
) {
  let sys = voyageSystems.findSystem(sysTag)
  voyageUiTutorial.setText(
    'Great!',
    'Move crewmember ' +
      cr.name +
      ' to the indicated ' +
      sys.system?.data.name +
      '\n\n(Click highlighted system to move)',
  )

  while (distanceUtil.distanceSimpleIJ(cr, sys) !== 0) {
    if (_skipTutorial) {
      return 0
    }

    voyageIndicators.moveToIJ(ind, sys)

    if (voyagePicker.get().selectedCrew !== cr) {
      yield* gen_selectCrew(ind, cr, 'Please select this crewmember')
    }

    yield 0
  }
  yield voyageUiTutorial.completeStep()
}

export function* generator_tutorial(): Generator<number, number, number> {
  console.log(namespace, 'starting tutorial')

  while (!voyageSaver.getIsLoaded()) {
    yield 0
  }

  let crew = l.filter(
    voyageCrew.getAll(),
    (c) => c.type === EVoyageCrewType.Crew,
  )

  voyageUiTutorial.setOpen(true)
  // assert.notNil(firstCrew, 'No crew!')

  voyageUiTutorial.setText(
    'Welcome to the battleship Dawn Star',
    `Use W,A,S,D or hold down the middle mouse button to move the camera\n\n(Move camera to continue)`,
  )

  let cameraX = voyageCamera.get().cameraX
  let cameraY = voyageCamera.get().cameraY

  while (
    cameraX === voyageCamera.get().cameraX &&
    cameraY === voyageCamera.get().cameraY
  ) {
    if (_skipTutorial) {
      break
    }
    yield 0
  }
  yield voyageUiTutorial.completeStep()

  let ind = voyageIndicators.create()

  yield* gen_selectCrew(ind, crew[0], 'Get life support up and running')
  yield* gen_moveToSystem(ind, crew[0], 'life-support-up')

  yield* gen_selectCrew(ind, crew[1], 'Get power support up and running')
  yield* gen_moveToSystem(ind, crew[1], 'reactor-1')

  yield* gen_selectCrew(ind, crew[2], 'Check sensors')
  yield* gen_moveToSystem(ind, crew[2], 'sensor-internal')

  if (!_skipTutorial) {
    voyageGameStatus_enemyShips.hitByWeapon(1, 0, 100)

    voyageUiTutorial.setText(
      'Oh no, a hull breach!',
      `Fires and hull breaches are fixed by moving crew NEXT to them. Careful, fires are dangerous.`,
    )
    let breach = l.filter(
      voyageCrew.getAll(),
      (c) => c.type === EVoyageCrewType.HullBreach,
    )
    if (breach.length > 0) {
      voyageIndicators.moveToIJ(ind, breach[0])

      while (!breach[0].isDead) {
        yield 0
      }
      voyageUiTutorial.completeStep()
    }
  }

  voyageIndicators.kill(ind)

  if (!_skipTutorial) {
    voyageUiTutorial.setText(
      'Advanced Controls',
      'Space - pause\nTab - switch crewmember\nMouse wheel - zoom\nRight-click - deselect ',
    )

    yield 5
  }

  voyageUiTutorial.setText('Tutorial complete!', 'The ship is yours, commander')

  if (_skipTutorial) {
    yield 2
  } else {
    yield 5
  }

  voyageUiTutorial.setText('', '')
  voyageUiTutorial.setOpen(false)

  console.log(namespace, 'ending tutorial')

  // voyageIndicators.moveToXY(ind, 100, 100)

  return 0
}
